/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { AbDropdown } from "abreact/input/AbDropdown";
import { AbIcon } from "abreact/misc/AbIcon";
import * as React from "react";
/**
 * Input control that allows the multiplexing of different input controls.
 * The user is offered a choice of which style of input they would like to provide,
 * eg A literal, a variable, or expression, in a (gray box dropdown)
 * Based on that first choice, the adjacent input control is shown.
 * https://confluence.abinitio.com/display/~jhoel/2020-09-14+Meeting+notes
 * @author jhoel
 */
export class AbMultiplexInput extends React.Component {
  render() {
    // const childCount = React.Children.count(this.props.children);
    const children = this.props.children;
    const currentIndex = this.props.value === undefined ? 0 : this.props.items.indexOf(this.props.value);
    return /*#__PURE__*/React.createElement("div", {
      className: CssUtils.composeClassNames("ab-multiplex-input", this.props.className),
      "data-test-id": this.props.dataTestId
    }, this.props.items.length > 1 && /*#__PURE__*/React.createElement(AbDropdown, {
      value: this.props.items[currentIndex],
      onChange: this.props.onChange,
      items: this.props.items,
      disabled: this.props.disabled,
      itemRenderer: this.props.itemRenderer,
      valueRenderer: this.props.valueRenderer,
      dataTestId: this.props.dataTestId + "-left-dropdown"
    }), this.props.items.length === 1 && this.props.alwaysDisplayMultiplexDropdown && /*#__PURE__*/React.createElement("div", {
      className: "ab-multiplex-single-type-no-choice-box",
      "data-test-id": this.props.dataTestId + "-single-type-no-choice-box"
    }, this.props.valueRenderer ? this.props.valueRenderer(this.props.items[0]) : this.props.items[0], /*#__PURE__*/React.createElement(AbIcon, {
      image: "absdk:transparent",
      altText: ""
    })), React.Children.map(children, (child, i) => {
      // only show the child with the activated index
      if (i === currentIndex) return child;else return null;
    }));
  }
}
//# sourceMappingURL=AbMultiplexInput.js.map
